export function getKey(record, idField) {
    return String(idField ? record.get(idField) : record.key);
}
function getTreeNode(record, children, idField, text, treeNodeProps, async, filterText) {
    const key = getKey(record, idField);
    return ({
        title: text,
        isLeaf: async ? undefined : (filterText ? (!children || !children.length) : !record.children || !record.children.length),
        children,
        record,
        ...record.get('__treeNodeProps'),
        ...treeNodeProps,
        selectable: record.dataSet.selection ? record.selectable : false,
        eventKey: key,
        key,
    });
}
export function getTreeNodes(dataSet, records, forceRenderKeys, renderer, onTreeNode, async, titleField, defaultExpandAll, optionsFilter, searchMatcher, filterText) {
    const { idField } = dataSet.props;
    if (records) {
        return records.reduce((array, record, index) => {
            if (record.status !== 'delete') {
                const children = defaultExpandAll || forceRenderKeys.indexOf(getKey(record, idField)) !== -1 || filterText
                    ? getTreeNodes(dataSet, record.children, forceRenderKeys, renderer, onTreeNode, async, titleField, defaultExpandAll, optionsFilter, searchMatcher, filterText)
                    : null;
                if (!searchMatcher || !filterText || (children && children.length) || searchMatcher(record, filterText)) {
                    if ((!optionsFilter || optionsFilter(record, index, records))) {
                        const node = getTreeNode(record, children, idField, renderer({ dataSet, record, text: record.get(titleField) }), onTreeNode({ dataSet, record }), async, filterText);
                        if (node) {
                            array.push(node);
                        }
                    }
                    else if (children) {
                        array.push(...children);
                    }
                }
            }
            return array;
        }, []);
    }
    return null;
}
